/**
 * MYMUSE scroll memory.
 *
 * - Refresh and back/forward return to the spot the visitor left, on desktop (`.page-wrapper` scrolls)
 *   and mobile (the document scrolls). On collection/search grids the position is anchored to the product
 *   card at the top of the screen, so it survives infinite scroll (`?page=N` URLs load a different set of cards).
 * - A new visit to a page starts at the top.
 * - Clicking the header logo while already on the home page scrolls smoothly to the top instead of reloading.
 */
(function () {
  var KEY_PREFIX = 'mm-scroll:';
  var CARD_SELECTOR = '.product-grid__item[id]';
  var squeeze = window.matchMedia('(min-width: 990px)');
  var restoring = false;
  var saveTimer = 0;

  try {
    history.scrollRestoration = 'manual';
  } catch (e) {}
  // Horizon switches mobile back to native restoration on resize; keep it manual
  squeeze.addEventListener('change', function () {
    setTimeout(function () {
      try {
        history.scrollRestoration = 'manual';
      } catch (e) {}
    }, 0);
  });

  function container() {
    if (squeeze.matches) {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper) return wrapper;
    }
    return document.scrollingElement || document.documentElement;
  }

  function key() {
    return KEY_PREFIX + location.pathname + location.search;
  }

  function read() {
    try {
      return JSON.parse(sessionStorage.getItem(key()) || 'null');
    } catch (e) {
      return null;
    }
  }

  // First product card still visible below the sticky header (or the last card, when scrolled past the grid),
  // with its distance from the viewport top
  function findAnchor() {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    var last = null;
    for (var i = 0; i < cards.length; i++) {
      var rect = cards[i].getBoundingClientRect();
      if (!rect.height) continue;
      last = { id: cards[i].id, offset: Math.round(rect.top) };
      if (rect.bottom > 80) return last;
    }
    return last;
  }

  function save() {
    if (restoring) return;
    var data = { y: Math.round(container().scrollTop) };
    var anchor = data.y > 0 ? findAnchor() : null;
    if (anchor) {
      data.a = anchor.id;
      data.o = anchor.offset;
    }
    try {
      sessionStorage.setItem(key(), JSON.stringify(data));
    } catch (e) {}
  }

  function scheduleSave() {
    if (saveTimer) return;
    saveTimer = setTimeout(function () {
      saveTimer = 0;
      save();
    }, 200);
  }

  function restore(saved) {
    if (!saved || !(saved.y > 0)) return;

    var started = Date.now();
    var reachedAt = 0;
    var events = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    restoring = true;

    function stop() {
      if (!restoring) return;
      restoring = false;
      events.forEach(function (type) {
        window.removeEventListener(type, stop, true);
      });
      save();
    }
    // The visitor takes over as soon as they scroll, tap or press a key
    events.forEach(function (type) {
      window.addEventListener(type, stop, { capture: true, passive: true });
    });

    // Retry while images, sections and grid pages load, then hold the position until the page settles
    (function step() {
      if (!restoring) return;
      var now = Date.now();
      if (now - started > 5000) return stop();

      var c = container();
      var target = saved.y;
      if (saved.a) {
        var card = document.getElementById(saved.a);
        target = card ? c.scrollTop + card.getBoundingClientRect().top - saved.o : null;
      }

      if (target != null) {
        var max = c.scrollHeight - c.clientHeight;
        var top = Math.max(0, Math.min(target, max));
        if (Math.abs(c.scrollTop - top) > 1) c.scrollTo({ top: top, behavior: 'instant' });
        if (target <= max + 1) {
          if (!reachedAt) reachedAt = now;
        } else {
          reachedAt = 0;
        }
      }

      if (reachedAt && document.readyState === 'complete' && now - reachedAt > 700) return stop();
      requestAnimationFrame(step);
    })();
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target === document ? document.scrollingElement : event.target;
      if (target === container()) scheduleSave();
    },
    { capture: true, passive: true }
  );
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });

  // Fresh loads only: a page restored from the back/forward cache already keeps its scroll position
  var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var navType = nav ? nav.type : performance.navigation && performance.navigation.type === 1 ? 'reload' : 'navigate';
  if (navType === 'reload' || navType === 'back_forward') {
    restore(read());
  }

  // Logo on the home page: back to the very top without a reload
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a.muse-header__logo[href]');
    if (!link) return;
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash) return;

    event.preventDefault();
    restoring = false;
    try {
      sessionStorage.removeItem(key());
    } catch (e) {}
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    container().scrollTo({ top: 0, behavior: reduce ? 'instant' : 'smooth' });
  });
})();
